'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/Properties';
const INIT_STATE = {
  propertyGroups: {},
  properties: {},
  requestState: RequestState.NOT_REQUESTED,
  searchQuery: ''
};
export function properties(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.RECEIVE_PROPERTIES:
      return Object.assign({}, state, {
        propertyGroups: action.propertyGroups,
        properties: action.properties
      });
    case Actions.REQUEST_PROPERTIES:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_FETCHING_PROPERTIES:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.FAIL_FETCHING_PROPERTIES:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    case Actions.UPDATE_SEARCH_QUERY:
      return Object.assign({}, state, {
        searchQuery: action.searchQuery
      });
    default:
      return state;
  }
}